import React, { useCallback, useEffect, useState } from "react";
import Informations from "./Informations";
import Note from "./Note";
import Addresses from "./Addresses";
import { useDispatch } from "react-redux";
import Comments from "./Comments/Comments";
import Interlocutors from "./Interlocutors";
import Actions from "./Actions/Actions";
import Location from "./Location/Location";
import Favorites from "../../Common/Favorites/Favorites";
const NewProspectForms = ({
  currentStatus,
  setActiveTab,
  activeTab,
  forms,
  setForms,
  customErrors,
  updateDeletedInterlocutors,
}) => {
  const dispatch = useDispatch();
  const [scrollableComment, setScrollableComment] = useState();

  const handleFormChange = useCallback(
    (name, formData) => {
      setForms({ ...forms, [name]: formData });
    },
    [forms, setForms]
  );

  const handleStatusChange = useCallback(
    (status) => {
      setForms((prev) => ({ ...prev, infos: { ...prev.infos, status } }));
    },
    [setForms]
  );

  // TODO - REDUCER
  useEffect(() => {
    return () => dispatch({ type: "CLEAR_CURRENT_PROSPECT" });
  }, [dispatch]);

  switch (activeTab) {
    case "Informations":
      return (
        <Informations
          initialValues={forms.infos}
          handleFormChange={handleFormChange}
          customErrors={customErrors}
        />
      );
    case "Note":
      return (
        <Note initialValues={forms.note} handleFormChange={handleFormChange} />
      );
    case "Interlocutors":
      return (
        <Interlocutors
          updateDeletedInterlocutors={updateDeletedInterlocutors}
          initialValues={forms.interlocutors}
          handleFormChange={handleFormChange}
        />
      );
    case "Pipeline action":
      return (
        <Actions
          handleStatusChange={handleStatusChange}
          currentStatus={currentStatus}
          initialValues={forms.actions}
          handleFormChange={handleFormChange}
        />
      );
    case "Addresses":
      return (
        <Addresses
          initialValues={forms.addresses}
          handleFormChange={handleFormChange}
        />
      );
    case "Comments":
      return (
        <Comments
          initialValues={forms.comments}
          handleFormChange={handleFormChange}
          scrollableComment={scrollableComment}
          setScrollableComment={setScrollableComment}
        />
      );
    case "Location":
      return (
        <Location
          initialValues={forms.geoEntity}
          handleFormChange={handleFormChange}
        />
      );

    case "Favorites":
      return (
        <Favorites
          view="PROSPECT"
          setActiveTab={setActiveTab}
          setScrollableComment={setScrollableComment}
        />
      );
    default:
      return (
        <Informations
          initialValues={forms.infos}
          handleFormChange={handleFormChange}
          customErrors={customErrors}
        />
      );
  }
};

export default NewProspectForms;
